import React from 'react'

export default function EventDetails(props) {
    var data = props.Data;
    var title = data.title;
    var location = data.location;
    var locationLink = data.locationLink;
    var body = data.body;
    var start = data.start;
    var end = data.end;
    const formatDate = function (d) {
        var date = new Date(d);
        var res = '';
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1);
        var yyyy = date.getFullYear();
        var HH = date.getHours();
        var MM = String(date.getMinutes());
        var AMPM = HH >= 12 ? 'pm' : 'am';
        HH = HH % 12;
        HH = HH ? HH : 12;
        MM = MM < 10 ? '0' + MM : MM;
        res = mm + '/' + dd + '/' + yyyy + ' ' + HH + ":" + MM + AMPM;
        return res
    }

    return (
        <div>
            <div className='row'>
                <h5 className='fw-bold'>{title}</h5>
                <p><a href={locationLink} target="_blank">{location}</a></p>
                <p>({formatDate(start)} - {formatDate(end)})</p>
                <p>{body}</p>
            </div>
        </div>
    )
}
